import classNames from 'classnames'
import parse from 'html-react-parser'

import style from './OrderManageFromHeader.module.scss'

type TOrderManageFromHeader = {
  title: string
  subtitle?: string
  description: string
}

// верхний блок с заголовками для форм упраления заявкой

export const OrderManageFromHeader = ({
  title,
  subtitle,
  description,
}: TOrderManageFromHeader) => {
  return (
    <div className={style.orderManageFormHeader}>
      <span className={classNames(style.title, 'h2')}>{title}</span>
      {subtitle && <span className='default-text'>{subtitle}</span>}

      <span className='default-text'>{parse(description)}</span>
    </div>
  )
}
